// src/components/signage/AuthMedia.js
// Wrapper components for <img> and <video> that load media via authenticated axios requests.
// Native <img src> / <video src> don't send JWT Authorization headers, so protected
// endpoints return 401. These components fetch via axios (which has auth interceptors)
// and render with blob URLs instead.
import React, { useState, useEffect } from 'react';
import { fetchMediaAsBlob } from '../../services/signageService';

export function AuthImage({ src, ...props }) {
    const [displayUrl, setDisplayUrl] = useState(null);

    useEffect(() => {
        if (!src) { setDisplayUrl(null); return; }
        let cancelled = false;
        fetchMediaAsBlob(src).then(url => { if (!cancelled) setDisplayUrl(url); });
        return () => { cancelled = true; };
    }, [src]);

    if (!displayUrl) return null;
    return <img src={displayUrl} {...props} />;
}

export function AuthVideo({ src, ...props }) {
    const [displayUrl, setDisplayUrl] = useState(null);

    useEffect(() => {
        if (!src) { setDisplayUrl(null); return; }
        let cancelled = false;
        fetchMediaAsBlob(src).then(url => { if (!cancelled) setDisplayUrl(url); });
        return () => { cancelled = true; };
    }, [src]);

    if (!displayUrl) return null;
    return <video src={displayUrl} {...props} />;
}
